import Grid from '@mui/material/Grid'
import InputCustom from '../../../atoms/input/InputCustom'
import SelectCustom from '../../../atoms/select/SelectCustom'
import { Typography } from '@mui/material'
import InvoiceTemplate from '../../../atoms/InvoiceTemplate/InvoiceTemplate'
import { useState } from 'react'
import CommonModal from '../../../atoms/modal/CommonModal'
import InvoicePreview from '../../../atoms/InvoicePreview/InvoicePreview'
import styles from '../index.module.scss'
import UploadLogo from '../../../atoms/UploadLogo/UploadLogo'
import GoogleAddressInput from '../../../atoms/input/GoogleAddressInput'

const options = [
	{ value: 'completed', label: 'Completed' },
	{ value: 'charged', label: 'Charged' },
	{ value: 'pending', label: 'Pending' },
]
const templates = [
	{
		id: 1,
		image: '/images/InvoiceTemplate01.svg',
		title: 'Standard',
		description: 'A simple, professional invoice template',
	},
	{
		id: 2,
		image: '/images/InvoiceTemplate02.svg',
		title: 'Modern',
		description: 'A clean, contemporary design',
	},
	{
		id: 3,
		image: '/images/InvoiceTemplate03.svg',
		title: 'Classic',
		description: 'Traditional invoice layout',
	},
]

const TemplateTaxTab = () => {
	const [data, setData] = useState({
		businessAddress: '',
	})
	const [selectedId, setSelectedId] = useState(1)
	const [open, setOpen] = useState(false)


	const handlePlaceSelected = (placeData) => {
		setUserDetails(prev => ({
			...prev,
			businessAddress: placeData.formattedAddress,
		}))
	}
	const handleTemplateClick = (id) => {
		setSelectedId(id)
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	return (
		<>
			<div className={styles.templateTaxTab}>
				<Grid container spacing={1.5} sx={{ marginBottom: '15px' }}>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.title}>
							<Typography variant="h6">Template</Typography>
						</div>
					</Grid>
					{templates.map((templates) => (
						<Grid size={{ xs: 6, sm: 4 }}>
							<InvoiceTemplate
								key={templates.id}
								image={templates.image}
								title={templates.title}
								description={templates.description}
								selected={selectedId === templates.id}
								onSelect={() =>
									handleTemplateClick(templates.id)
								}
							/>
						</Grid>
					))}
				</Grid>
				<Grid container spacing={1.5}>
					<Grid size={{ xs: 12, md: 6 }}>
						<Grid container spacing={1.5}>
							<Grid size={{ xs: 12, md: 12 }}>
								<div className={styles.title}>
									<Typography variant="h6">
										Business Information
									</Typography>
								</div>
							</Grid>
							<Grid size={{ xs: 12, md: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="businessName"
										className={styles.label}
									>
										Company Logo
									</label>
									<UploadLogo />
								</div>
							</Grid>
							<Grid size={{ xs: 12, md: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="businessName"
										className={styles.label}
									>
										Business Name
									</label>
									<InputCustom
										type="text"
										name="businessName"
										id="businessName"
										placeholder="Enter business name"
										className=""
									/>
								</div>
							</Grid>
							<Grid size={{ xs: 12, md: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="address"
										className={styles.label}
									>
										Address
									</label>
									<GoogleAddressInput
										data-cy="businessAddress"
										placeholder="Business Address"
										name="businessAddress"
										value={data.businessAddress}
										setDataFunction={setData}
										data={data}
										onPlaceSelected={handlePlaceSelected}
										required={true}
									/>
								</div>
							</Grid>

							<Grid size={{ xs: 12, sm: 6 }}>
								<div className={styles.formField}>
									<label
										htmlFor="Phone"
										className={styles.label}
									>
										Phone
									</label>
									<InputCustom
										type="text"
										name="phone"
										id="phone"
										placeholder="Phone number"
										className=""
									/>
								</div>
							</Grid>

							<Grid size={{ xs: 12, sm: 6 }}>
								<div className={styles.formField}>
									<label
										htmlFor="Email"
										className={styles.label}
									>
										Email
									</label>
									<InputCustom
										type="email"
										name="email"
										id="email"
										placeholder="Email address"
										className=""
									/>
								</div>
							</Grid>
							<Grid size={{ xs: 12, sm: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="Tax ID / Business Number"
										className={styles.label}
									>
										Tax ID / Business Number
									</label>
									<InputCustom
										type="text"
										name="taxId"
										id="taxId"
										placeholder="Tax ID / Business Number"
										className=""
									/>
								</div>
							</Grid>
						</Grid>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<Grid container spacing={1.5}>
							<Grid size={{ xs: 12, md: 12 }}>
								<div className={styles.title}>
									<Typography variant="h6">
										Tax Information
									</Typography>
								</div>
							</Grid>
							<Grid size={{ xs: 12, sm: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="Tax Region"
										className={styles.label}
									>
										Tax Region
									</label>
									<SelectCustom
										label="Default"
										options={options}
									/>
								</div>
							</Grid>
							<Grid size={{ xs: 12, md: 12 }}>
								<div className={styles.formField}>
									<label
										htmlFor="taxRate"
										className={styles.label}
									>
										Tax Rate (%)
									</label>
									<InputCustom
										type="number"
										name="taxRate"
										id="taxRate"
										placeholder="0"
										className=""
									/>
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</div>
			<CommonModal
				open={open}
				handleClose={handleClose}
				heading="Standard"
			>
				<InvoicePreview />
			</CommonModal>
		</>
	)
}

export default TemplateTaxTab
